import { useMemo } from "react";

import { TProductDetail } from "@/api/services/main/organization/product/dtos/product.dto";
import { ProductEditForm } from "@/features/organization/product/components/product-form/ProductEditForm";
import { convertDetailToFormData } from "@/features/organization/product/utils/productForm";

type TProductEditPageProps = {
  product: TProductDetail;
};

export const ProductEditPage = ({ product }: TProductEditPageProps) => {
  // Memoize so field-array row ids stay stable across re-renders — otherwise the leave-confirm
  // blocker sees a "change" on every render even when the user edited nothing.
  const defaultValues = useMemo(() => (product ? convertDetailToFormData(product) : null), [product]);

  if (!defaultValues) return null;

  return (
    <ProductEditForm
      mode="edit"
      title={product.name}
      productId={product.id}
      isDefault={product.isDefault}
      isTierDiscountTarget={product.isTierDiscountTarget}
      defaultValues={defaultValues}
    />
  );
};
